import  * as React from "react";
import { observer } from "mobx-react";
import { IUnitButtonParams } from "./IUnitButtonParams";

@observer
export class UnitButton extends React.Component<IUnitButtonParams>{
    constructor(props: IUnitButtonParams) {
        super(props, undefined);
    }
    changeUnit(newValue: string): void {
        if(this.props.changeUnit)
            this.props.changeUnit(newValue);
    }

    render() {
        return <div className="UnitButton change-unit">

            {this.props.unitSystem === 1 &&
                <span className="unit-button-table metric-button" onClick={() => this.changeUnit("e")
                }>m, m/s<img className="hidden-print" src="Images/MultiShotControl/change-units-icon.svg" alt="change unit icon"/></span>
            }
            {this.props.unitSystem === 2 &&
                <span className="unit-button-table european-button" onClick={() => this.changeUnit("u")
            }>m, Mph<img className="hidden-print" src="Images/MultiShotControl/change-units-icon.svg" alt="change unit icon"/></span>
            }
            {this.props.unitSystem === 3 &&
                <span className="unit-button-table us-button" onClick={() => this.changeUnit("j")
            }>Yds/Ft, Mph<img className="hidden-print" src="Images/MultiShotControl/change-units-icon.svg" alt="change unit icon"/></span>
            }
            {this.props.unitSystem === 4 &&
                <span className="unit-button-table japanese-button" onClick={() => this.changeUnit("m")
            }>Yds, m/s<img className="hidden-print" src="Images/MultiShotControl/change-units-icon.svg" alt="change unit icon"/></span>
            }
        </div >;
    }
}
